import {PersonasActions, PersonasActionTypes} from './personas.actions';
import {initialState, personasAdapter, PersonasState} from './personas.state';

export function personasReducer(
  state = initialState,
  action: PersonasActions
): PersonasState {
  switch (action.type) {
    // load
    case PersonasActionTypes.PERSONAS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case PersonasActionTypes.PERSONAS_LOAD_SUCCESS: {
      return personasAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case PersonasActionTypes.PERSONAS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // Register
    case PersonasActionTypes.PERSONAS_REGISTRER_REDIRECT: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case PersonasActionTypes.PERSONAS_REGISTRER_SUCCESS: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case PersonasActionTypes.PERSONAS_REGISTRER_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: 'Occurio un error al registrar persona'
      };
    }
    // default
    default: {
      return state;
    }
  }
}
